export class Version {
    private static major: number = 1;
    private static minor: number = 1;
    private static revision: number = 0;
    private static build: number = 876;

    public static toString(): string {
        return Version.major + "." + Version.minor + "." + Version.revision + "." + Version.build;
    }
}